import { getGfAccessToken } from "./requestToolsV3";

export function buildAuthHeaders() {
  const headers = new Headers();
  const token = getGfAccessToken();

  headers.append("Authorization", `Bearer ${token}`);

  headers.append("content-type", "application/json");
  return headers;
}

export function buildUrl({ path = "", filters = {} }) {
  const url = new URL(path);

  Object.entries(filters).forEach(([name, value]) =>
    url.searchParams.append(`filter[${name}]`, value)
  );

  return url.toString();
}
